export default __webpack_public_path__ + "static/media/SI.93f13d66.svg";